import * as React from 'react';
import styled from 'styled-components';
import errorImg from '@/assets/illustrations/error-robot.svg';

const Container = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 42px;
  flex-direction: column;
  align-items: center;
  img {
    width: 182px;
    margin-bottom: 24px;
  }
  & .titleError {
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #161d1f;
    font-weight: 700;
    margin-bottom: 16px;
  }

  & .messageError {
    color: #4f6168;
    font-size: 14px;
    font-weight: 400;
  }
`;

const ErrorMessage = () => (
  <Container>
    <img src={errorImg} alt="" />
    <p className="titleError">Ocurrió un problema inesperado</p>
    <p className="messageError">
      Por favor, vuelve a intentarlo en unos minutos.
    </p>
  </Container>
);

export default ErrorMessage;
